<template>
  <div id="home">
    <div id="carouselExampleIndicators" class="carousel slide carousel-fade" data-ride="false">
  <ol class="carousel-indicators">
    <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
    <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
    <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
  </ol>
  <div class="carousel-inner">
    <div class="first-slide carousel-item active" data-interval="5000">
      <div class="carousel-caption d-none d-md-block">
        <img class="carousel-img w-auto" src="../assets/img/illustration-02.png" alt="">
        <h1 class="carousel-title-caption">Your success is our success</h1>
      </div>
    </div>
    <div class="second-slide carousel-item" data-interval="5000">
      <div class="carousel-caption d-none d-md-block">        
        <img class="carousel-img w-auto" src="../assets/img/illustration-03.png" alt="">
        <h1 class="carousel-title-caption">Innovation is on us</h1>
      </div>
    </div>
    <div class="third-slide carousel-item" data-interval="5000">
      <div class="carousel-caption d-none d-md-block">
        <img class="carousel-img w-auto" src="../assets/img/illustration-01.png" alt="">
        <h1 class="carousel-title-caption">We simplify your business</h1>
      </div>
    </div>
  </div>
  <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="sr-only">Previous</span>
  </a>
  <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="sr-only">Next</span>
  </a>
</div>
  </div>
</template>

<script>
export default {
  name: 'Carousel',
}
</script>

<style>

</style>